import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Header from './components/Header';
import MainContent from './components/MainContent';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Impressum from './components/Impressum';
import Datenschutzerklaerung from './components/Datenschutzerklaerung';
import Footer from './components/Footer';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0e5d54', // Teal-Blue
    },
    secondary: {
      main: '#ff6f61', // Coral
    },
    background: {
      default: '#f4f4f9', // Light Gray for the background
      paper: '#ffffff', // White for card backgrounds
    },
    text: {
      primary: '#212121', // Dark Gray for primary text
      secondary: '#757575', // Medium Gray for secondary text
    },
  },
  typography: {
    fontFamily: 'Poppins, Arial, sans-serif',
    h1: {
      fontSize: '3rem',
      fontWeight: 700,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
    },
    h5: {
      fontSize: '1.5rem',
      fontWeight: 500,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
});


function App() {
  return (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<MainContent />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/privacy-policy" element={<Datenschutzerklaerung></Datenschutzerklaerung>} />
        {/* Add more routes as needed */}
      </Routes>
      <Footer />
    </Router>
    
  </ThemeProvider>
  );
}

export default App;
